export let attestationOptions = "/attestation/options";
export let attestationResult = "/attestation/result";
export let assertionOptions = "/assertion/options";
export let assertionResult = "/assertion/result";
